"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const siteText_1 = tslib_1.__importDefault(require("../../mixins/siteText"));
const sitetext_1 = require("../../filters/sitetext");
const AuthenticationFactor_1 = require("../../enums/AuthenticationFactor");
const ElementIds_1 = require("../../enums/ElementIds");
exports.default = vue_1.default.extend({
    name: 'step-up-option',
    props: {
        stepUpCategory: {
            type: Object,
            required: true,
        },
        isSelectedCategory: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    data: () => {
        return {
            internalSelectedDestination: null,
        };
    },
    mixins: [siteText_1.default],
    filters: {
        sitetext: sitetext_1.siteTextFilter,
    },
    computed: {
        stepUpType() {
            return this.stepUpCategory.StepUpModel.AuthenticationFactorValue;
        },
        showDropdown() {
            var _a;
            return this.isSelectedCategory && ((_a = this.stepUpCategory.StepUpModel.Destinations) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        getStrings() {
            return {
                label: this.getText('Dropdown.Label'),
            };
        },
        getItems() {
            let items = [];
            this.stepUpCategory.StepUpModel.Destinations.forEach((destination) => {
                items.push({
                    label: destination.MaskedAddress,
                    value: destination.$id,
                });
            });
            return items;
        },
        selectedDestination: {
            get() {
                var _a;
                const id = (_a = this.internalSelectedDestination) === null || _a === void 0 ? void 0 : _a.$id;
                if (!id)
                    return [];
                const destination = this.stepUpCategory.StepUpModel.Destinations.find(dest => dest.$id === id);
                if (!destination)
                    return [];
                return [destination.$id];
            },
            set(destinationId) {
                const destination = this.stepUpCategory.StepUpModel.Destinations.find(dest => dest.$id === destinationId[0]);
                this.internalSelectedDestination = destination ? destination : null;
                this.$emit('stepup-destination-selected', this.internalSelectedDestination);
            },
        },
        elementIds: () => ElementIds_1.ElementIds,
    },
    methods: {
        buttonChanged() {
            this.$emit('stepup-option-selected', this.stepUpCategory);
            this.$emit('stepup-destination-selected', this.internalSelectedDestination);
        },
        getText(resource) {
            let type = '';
            switch (this.stepUpCategory.StepUpModel.AuthenticationFactorValue) {
                case AuthenticationFactor_1.AuthenticationFactor.SmsCode:
                    type = 'SMS';
                    break;
                case AuthenticationFactor_1.AuthenticationFactor.EmailCode:
                    type = 'Email';
                    break;
                case AuthenticationFactor_1.AuthenticationFactor.VoiceCode:
                    type = 'VoiceCall';
                    break;
                case AuthenticationFactor_1.AuthenticationFactor.Token:
                    type = 'Token';
                    break;
                case AuthenticationFactor_1.AuthenticationFactor.TOTP:
                    type = 'TOTP';
                    break;
            }
            return this.getSiteText(`Forgot.${type}.${resource}`);
        },
    },
    mounted() {
        var _a;
        if (((_a = this.stepUpCategory.StepUpModel.Destinations) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            this.internalSelectedDestination = this.stepUpCategory.StepUpModel.Destinations[0];
        }
    },
});
